module.exports = __webpack_public_path__ + "static/media/video_thumb.6334b595.png";